import axios from 'axios';
import { CaseRequestInfoModel } from 'app/edozvola/cases/case-request-info-form/model/case-request-info-form.model';
const caseBaseUrl = '/api/cases';

export const fetchCaseRequestInfo = async (idCase: string): Promise<any> => {
  if (idCase) {
    return await new Promise((resolve, reject) => {
      axios
        .get(`${caseBaseUrl}/${idCase}/request-info`)
        .then(response => resolve(response.data))
        .catch(error => reject(error));
    });
  }
};

export const saveCaseRequestInfo = async (idCase: string, values: CaseRequestInfoModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`${caseBaseUrl}/${idCase}/request-info`, values)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });
};
